import React from 'react'

import { Beneficiary } from './Beneficiary/Beneficiary'

import { BeneficiaryType } from 'views/TerminateContract/TerminateForm/initialValues'

interface BeneficiariesProps {
  beneficiaries: BeneficiaryType[]
}

export const Beneficiaries: React.FC<BeneficiariesProps> = ({
  beneficiaries,
}) => {
  return beneficiaries.map((_, index) => (
    <Beneficiary
      // eslint-disable-next-line @eslint-react/no-array-index-key
      key={`beneficiary-${index}`}
      index={index}
    />
  ))
}
